import React from "react";

const ErrorMessage: React.FC = () => (
  <div className="text-red-400 text-center">
    <p>Something went wrong. Please try again later.</p>
  </div>
);

export default ErrorMessage;
